<style scoped>
    p{
        margin: 0 0 0px;
    }
</style>
<template>
    <el-form :model="consumerCouponInfo"
             v-form
             style="width:500px;"
             addAction= "dbtCard/addDealer.action"
             @onAdded="onSaved"
             @onEdited="onSaved"
             :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
            <el-input v-model="consumerCouponInfo.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
            <el-input v-model="consumerCouponInfo.phone"  placeholder="请输入11位手机号"></el-input>
        </el-form-item>
        <el-form-item label="充值数量" prop="cardCount">
            <el-input v-model="consumerCouponInfo.cardCount" type="number" min="1" placeholder="请输入0以上的整数值"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary">提交</el-button>
            <div>
                <p>温馨提示：</p>
                <p>1、新增合伙人名额限制5个，便于前期拓展使用。</p>
                <p>2、合伙人实名及公司认证资料需线下督促完成。</p>
                <p>3、充值收费等事项，请于线下沟通协商完成。</p>
                <p>4、账号一经提交即创建成功，无法删除和更改。</p>
            </div>
        </el-form-item>

    </el-form>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'save-consumer-coupons',
  components: { TableTemplate },
  data () {
    return {
      consumerCouponInfo: {
        name: null,
        purpose: null,
        effectiveDays: 30,
        usageMethod: null,
        usageTip: null
      },
      options: [{
        value: 30,
        label: '领取后，30天内有效'
      }],
      rules: {
        packageName: [
          { required: true, message: '请输入礼包名称', trigger: 'blur' }
        ],
        packageDesc: [
          { required: true, message: '请输入礼品介绍', trigger: 'blur' }
        ],
        rightsCardNum: [
          { required: true, message: '请输入权益卡数量', trigger: 'blur' }
        ],
        retailPrice: [
          { required: true, message: '请输入零售价', trigger: 'blur' }
        ],
        dealerProfit: [
          { required: true, message: '请输入合伙人奖励金额', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.consumerCouponInfo.id = this.$route.params.id
  },
  methods: {
    onSaved () {
      this.$message({ type: 'success', message: '操作成功！' })
      return true
    }
  }
}
</script>
